import React from 'react';
import PropTypes from 'prop-types';
// Core components
import { IconButton } from 'components/core/Button';

const BaseIconButton = ({ tooltipId, defaultTooltipId, ...otherProps }) => (
  <IconButton
    tooltip={tooltipId || defaultTooltipId}
    {...otherProps}
  />
);

BaseIconButton.propTypes = {
  tooltipId: PropTypes.string,
  defaultTooltipId: PropTypes.string,
};

BaseIconButton.defaultProps = {
  tooltipId: null,
  defaultTooltipId: null,
};

export const AccessesIconButton = (props) => <BaseIconButton iconId="btnAccesses" defaultTooltipId="tooltip.accesses" {...props} />;
export const AccessWaysIconButton = (props) => <BaseIconButton iconId="btnAccessWays" defaultTooltipId="tooltip.accessWays" {...props} />;
export const AccountIconButton = (props) => <BaseIconButton iconId="btnAccount" defaultTooltipId="tooltip.accessWays" {...props} />;
export const AddAltIconButton = (props) => <BaseIconButton iconId="btnAddAlt" defaultTooltipId="tooltip.add" {...props} />;
export const AddCarparkIconButton = (props) => <BaseIconButton iconId="btnAddCarpark" defaultTooltipId="tooltip.addCarparks" {...props} />;
export const AddCircleIconButton = (props) => <BaseIconButton iconId="btnAddCircle" defaultTooltipId="tooltip.add" {...props} />;
export const AddIconButton = (props) => <BaseIconButton iconId="btnAdd" defaultTooltipId="tooltip.add" {...props} />;
export const AddRightIconButton = (props) => <BaseIconButton iconId="btnAddRight" defaultTooltipId="tooltip.add" {...props} />;
export const AddBookingIconButton = (props) => <BaseIconButton iconId="btnAddPlanning" defaultTooltipId="tooltip.add" {...props} />;
export const AdvancedFiltersIconButton = (props) => <BaseIconButton iconId="btnExpand" defaultTooltipId="tooltip.advancedFilters" {...props} />;
export const BasicFiltersIconButton = (props) => <BaseIconButton iconId="btnCollapse" defaultTooltipId="tooltip.basicFilters" {...props} />;
export const CancelIconButton = (props) => <BaseIconButton iconId="btnCancel" defaultTooltipId="tooltip.cancel" {...props} />;
export const CategorizeIconButton = (props) => <BaseIconButton iconId="btnCategorize" defaultTooltipId="tooltip.categorize" {...props} />;
export const CheckoutIconButton = (props) => <BaseIconButton iconId="btnCheckout" defaultTooltipId="tooltip.checkout" {...props} />;
export const ChooseIconButton = (props) => <BaseIconButton iconId="btnChoose" defaultTooltipId="tooltip.choose" {...props} />;
export const ClearFiltersIconButton = (props) => <BaseIconButton iconId="btnClearFilters" defaultTooltipId="tooltip.clearFilters" {...props} />;
export const ClearIconButton = (props) => <BaseIconButton iconId="btnClose" defaultTooltipId="tooltip.clear" {...props} />;
export const CloseIconButton = (props) => <BaseIconButton iconId="btnClose" defaultTooltipId="tooltip.close" {...props} />;
export const DeleteAllIconButton = (props) => <BaseIconButton iconId="btnDeleteAll" defaultTooltipId="tooltip.deleteAll" {...props} />;
export const DeleteIconButton = (props) => <BaseIconButton iconId="btnDelete" defaultTooltipId="tooltip.delete" {...props} />;
export const DeleteUserIconButton = (props) => <BaseIconButton iconId="btnDeleteCustomer" defaultTooltipId="tooltip.delete" {...props} />;
export const DisplayIconButton = (props) => <BaseIconButton iconId="btnDisplay" defaultTooltipId="tooltip.display" {...props} />;
export const DisplayListIconButton = (props) => <BaseIconButton iconId="btnDisplayList" defaultTooltipId="tooltip.displayList" {...props} />;
export const DisplayTableIconButton = (props) => <BaseIconButton iconId="btnTable" defaultTooltipId="tooltip.displayTable" {...props} />;
export const DisplayBarChartIconButton = (props) => <BaseIconButton iconId="btnBarChart" defaultTooltipId="tooltip.displayChart" {...props} />;
export const DuplicateIconButton = (props) => <BaseIconButton iconId="btnDuplicate" defaultTooltipId="tooltip.duplicate" {...props} />;
export const EditAltIconButton = (props) => <BaseIconButton iconId="btnEditAlt" {...props} defaultTooltipId="tooltip.edit" />;
export const EditIconButton = (props) => <BaseIconButton iconId="btnEdit" {...props} defaultTooltipId="tooltip.edit" />;
export const GetIconButton = (props) => <BaseIconButton iconId="btnGet" {...props} />;
export const HelpIconButton = (props) => <BaseIconButton iconId="btnHelp" {...props} />;
export const HideIconButton = (props) => <BaseIconButton iconId="btnHide" defaultTooltipId="tooltip.hide" {...props} />;
export const HistoryIconButton = (props) => <BaseIconButton iconId="btnHistory" defaultTooltipId="tooltip.history" {...props} />;
export const InfoIconButton = (props) => <BaseIconButton iconId="btnInfo" {...props} />;
export const InstallationInsctructionsIconButton = (props) => <BaseIconButton iconId="btnInstallationInstructions" {...props} />;
export const LeftArrowIconButton = (props) => <BaseIconButton iconId="btnChevronLeft" {...props} />;
export const LessFiltersIconButton = (props) => <BaseIconButton iconId="btnFiltersLess" defaultTooltipId="tooltip.lessFilters" {...props} />;
export const ManageIconButton = (props) => <BaseIconButton iconId="btnManage" defaultTooltipId="tooltip.manage" {...props} />;
export const MenuDownIconButton = (props) => <BaseIconButton iconId="btnMenuDown" {...props} />;
export const MenuIconButton = (props) => <BaseIconButton iconId="btnMenu" {...props} />;
export const MenuLeftIconButton = (props) => <BaseIconButton iconId="btnMenuLeft" {...props} />;
export const MenuMoreIconButton = (props) => <BaseIconButton iconId="btnMoreVert" {...props} />;
export const MenuRightIconButton = (props) => <BaseIconButton iconId="btnMenuRight" {...props} />;
export const MoreFiltersIconButton = (props) => <BaseIconButton iconId="btnFiltersMore" defaultTooltipId="tooltip.moreFilters" {...props} />;
export const NotificationsIconButton = (props) => <BaseIconButton iconId="btnNotifications" defaultTooltipId="tooltip.notifications" {...props} />;
export const NotificationsTestIconButton = (props) => <BaseIconButton iconId="btnNotificationsTest" defaultTooltipId="tooltip.notificationsTest" {...props} />;
export const ParkingIconButton = (props) => <BaseIconButton iconId="btnParking" defaultTooltipId="tooltip.parking" {...props} />;
export const PaymentActionsIconButton = (props) => <BaseIconButton iconId="btnPaymentActions" defaultTooltipId="tooltip.parking" {...props} />;
export const PingIconButton = (props) => <BaseIconButton iconId="btnPing" defaultTooltipId="tooltip.ping" {...props} />;
export const PlanningIconButton = (props) => <BaseIconButton iconId="btnPlanning" defaultTooltipId="tooltip.planning" {...props} />;
export const RebootIconButton = (props) => <BaseIconButton iconId="btnReboot" defaultTooltipId="tooltip.reboot" {...props} />;
export const RefreshIconButton = (props) => <BaseIconButton iconId="btnRefresh" defaultTooltipId="tooltip.refresh" {...props} />;
export const RemoveCarparkIconButton = (props) => <BaseIconButton iconId="btnRemoveCarpark" defaultTooltipId="tooltip.removeCarparks" {...props} />;
export const RemoveFiltersIconButton = (props) => <BaseIconButton iconId="btnFiltersRemove" defaultTooltipId="tooltip.removeFilters" {...props} />;
export const ReplaceIconButton = (props) => <BaseIconButton iconId="btnReplace" defaultTooltipId="tooltip.replace" {...props} />;
export const ResetIconButton = (props) => <BaseIconButton iconId="btnReset" defaultTooltipId="tooltip.reset" {...props} />;
export const SelectIconButton = (props) => <BaseIconButton iconId="btnSelect" defaultTooltipId="tooltip.select" {...props} />;
export const EmailToSendIconButton = (props) => <BaseIconButton iconId="btnEmailToSend" {...props} />;
export const SlugIconButton = (props) => <BaseIconButton iconId="btnSlug" defaultTooltipId="tooltip.slugManagement" {...props} />;
export const SyncIconButton = (props) => <BaseIconButton iconId="btnSync" defaultTooltipId="tooltip.synchronize" {...props} />;
export const RightArrowIconButton = (props) => <BaseIconButton iconId="btnChevronRight" {...props} />;
export const SearchIconButton = (props) => <BaseIconButton iconId="btnSearch" defaultTooltipId="tooltip.search" {...props} />;
export const TriggerDoorIconButton = (props) => <BaseIconButton iconId="btnOpenDoor" defaultTooltipId="tooltip.openDoor" {...props} />;
export const TriggerIconButton = (props) => <BaseIconButton iconId="btnTrigger" defaultTooltipId="tooltip.trigger" {...props} />;
export const UserPhoneIconButton = (props) => <BaseIconButton iconId="btnUserPhone" defaultTooltipId="tooltip.insertMynumber" {...props} />;
export const ValidateIconButton = (props) => <BaseIconButton iconId="btnValidate" defaultTooltipId="tooltip.validate" {...props} />;
export const ValidatePaymentIconButton = (props) => <BaseIconButton iconId="btnValidatePayment" defaultTooltipId="tooltip.validatePayment" {...props} />;

// Navigation buttons
export const NavFirstPageIconButton = (props) => <BaseIconButton iconId="btnFirstPage" {...props} />;
export const NavPrevPageIconButton = (props) => <BaseIconButton iconId="btnPrevPage" {...props} />;
export const NavNextPageIconButton = (props) => <BaseIconButton iconId="btnNextPage" {...props} />;
export const NavLastPageIconButton = (props) => <BaseIconButton iconId="btnLastPage" {...props} />;

// Shortcut button
export const ShortcutIconButton = ({ path, ...otherProps }) => (
  <BaseIconButton
    iconId="btnOpenInNew"
    defaultTooltipId="tooltip.displayInNew"
    path={{ path, targetBlank: true }}
    {...otherProps}
  />
);

ShortcutIconButton.propTypes = {
  path: PropTypes.string.isRequired,
};

// Expand/collapse button
export const CollapseIconButton = ({ open, ...otherProps }) => <BaseIconButton iconId={open ? 'btnChevronUp' : 'btnChevronDown'} {...otherProps} />;

CollapseIconButton.propTypes = {
  open: PropTypes.bool.isRequired,
};

// Expand/collapse row button
export const CollapseRowIconButton = ({ expanded, ...otherProps }) => <IconButton iconId={expanded ? 'btnChevronDown' : 'btnChevronRight'} {...otherProps} />;

CollapseRowIconButton.propTypes = {
  expanded: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./components/buttons/IconButtons.js